import { SelectedLifestyleUUID } from './selectedLifestylesTypes';

export class SelectedLifestyleCache {
  static selectedLifestyleInCreateMessageForm() {
    return 'selected-lifestyle-in-create-message-form';
  }

  static selectedCompanyLifestyleInCreateMessageForm() {
    return 'selected-company-lifestyle-in-create-message-form';
  }

  static downloadUrls(uuid: SelectedLifestyleUUID) {
    return `selected-lifestyle-${uuid}-download-urls`;
  }
}
